<template>
  <transition-group
    name="notification"
    tag="div"
    class="pointer-events-none fixed bottom-4 right-4 z-[90] flex w-[calc(100%-2rem)] max-w-md flex-col gap-3 sm:bottom-6 sm:right-6 sm:w-full"
    aria-live="polite"
    aria-atomic="true"
  >
    <article
      v-for="notification in notifications"
      :key="notification.id"
      class="app-notification"
      :class="notificationConfig(notification.type).cardClass"
      :role="notification.type === 'error' ? 'alert' : 'status'"
    >
      <div class="flex items-start gap-3">
        <span
          class="notification-icon flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl text-sm shadow-lg"
          :class="notificationConfig(notification.type).iconClass"
        >
          <i :class="['fas', notification.icon || notificationConfig(notification.type).icon]"></i>
        </span>
        <div class="min-w-0 flex-1 pt-0.5">
          <p class="text-sm font-black text-slate-950">{{ notification.title || notificationConfig(notification.type).title }}</p>
          <p v-if="notification.message" class="mt-1 text-sm font-semibold leading-relaxed text-slate-600">{{ notification.message }}</p>
          <button
            v-if="notification.actionLabel && notification.onAction"
            type="button"
            class="mt-3 inline-flex items-center justify-center rounded-xl bg-white/80 px-3 py-2 text-xs font-black text-slate-950 shadow-sm transition hover:bg-white"
            @click="runAction(notification)"
          >
            {{ notification.actionLabel }}
          </button>
        </div>
        <button type="button" class="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl text-slate-400 transition hover:bg-white/70 hover:text-slate-700" aria-label="Fermer la notification" @click="dismiss(notification.id)">
          <i class="fas fa-times text-xs"></i>
        </button>
      </div>
      <div v-if="notification.duration !== 0" class="mt-3 h-1 overflow-hidden rounded-full bg-white/70">
        <div class="notification-progress h-full rounded-full" :class="notificationConfig(notification.type).barClass" :style="{ animationDuration: (notification.duration || 4200) + 'ms' }"></div>
      </div>
    </article>
  </transition-group>
</template>

<script>
export default {
  name: 'AppNotifications',
  computed: {
    notifications() {
      return this.$store.state.notifications || []
    },
  },
  methods: {
    dismiss(id) {
      this.$store.dispatch('dismissNotification', id)
    },
    runAction(notification) {
      notification.onAction()
      this.dismiss(notification.id)
    },
    notificationConfig(type) {
      const configs = {
        success: { title: 'Enregistré', icon: 'fa-check', cardClass: 'app-notification-success', iconClass: 'app-notification-icon-success', barClass: 'app-notification-progress-success' },
        error: { title: 'Action impossible', icon: 'fa-exclamation', cardClass: 'app-notification-danger', iconClass: 'app-notification-icon-danger', barClass: 'app-notification-progress-danger' },
        warning: { title: 'À vérifier', icon: 'fa-exclamation-triangle', cardClass: 'app-notification-warning', iconClass: 'app-notification-icon-warning', barClass: 'app-notification-progress-warning' },
        info: { title: 'Information', icon: 'fa-info', cardClass: 'app-notification-info', iconClass: 'app-notification-icon-info', barClass: 'app-notification-progress-info' },
      }
      return configs[type] || configs.info
    },
  },
}
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: opacity 220ms ease, transform 220ms ease;
}

.notification-enter,
.notification-leave-to {
  opacity: 0;
  transform: translateY(14px) scale(0.98);
}

.notification-move {
  transition: transform 220ms ease;
}

.notification-icon {
  animation: notification-pop 320ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.notification-progress {
  animation-name: notification-progress;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

@keyframes notification-pop {
  0% { transform: scale(0.76); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes notification-progress {
  from { width: 100%; }
  to { width: 0%; }
}
</style>
